import errors from './errors/index.js';
import translation from './translation/index.js';
const ko = {
    translation,
    errors,
};
export default Object.freeze(ko);
